import {createAction, props} from '@ngrx/store';
import {CustomConfiguration} from './custom-configuration.reducer';

export const loadCustomConfigurations = createAction(
  '[CustomConfiguration] Load CustomConfigurations'
);

export const loadCustomConfigurationsSuccess = createAction(
  '[CustomConfiguration] Load CustomConfigurations Success',
  props<{ config: CustomConfiguration }>()
);

export const saveCustomConfigurationSuccess = createAction(
  '[CustomConfiguration] CustomConfigurations saved successfully',
  props<{ config: CustomConfiguration }>()
);

export const saveCustomConfiguration = createAction(
  '[CustomConfiguration] CustomConfigurations save',
  props<{ config: CustomConfiguration }>()
);
